import axios from '../http'

function query(data) {
    return axios.post('/event/round/query', data);
}


function printStartOrder(id) {
    const url = "/event/round/printStartOrder?id="+id;
    return axios.get(url, { responseType: 'blob' }).then((res) => {
        const pdfUrl = window.URL.createObjectURL(new Blob([res], { type: 'application/pdf;charset=UTF-8'}));
        const newWindow = window.open(pdfUrl);
        window.URL.revokeObjectURL(newWindow);
    })
}

function exportStartOrder(id){
    const url = "/event/round/exportStartOrder?id="+id;
    return axios.get(url, { responseType: 'blob' }).then((res) => {
        const link = document.createElement('a');
        link.href = URL.createObjectURL(res);
        link.download = "Start List by Round.xlsx";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    })
}

function printResultOrder(id) {
    const url = "/event/round/printResultOrder?id="+id;
    return axios.get(url, { responseType: 'blob' }).then((res) => {
        const pdfUrl = window.URL.createObjectURL(new Blob([res], { type: 'application/pdf;charset=UTF-8'}));
        const newWindow = window.open(pdfUrl);
        window.URL.revokeObjectURL(newWindow);
    })
}


function exportResultOrder(id){
    const url = "/event/round/exportResultOrder?id="+id;
    return axios.get(url, { responseType: 'blob' }).then((res) => {
        const link = document.createElement('a');
        link.href = URL.createObjectURL(res);
        link.download = "Results by Round.xlsx";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    })
}


export default {
    query,
    printStartOrder,
    exportStartOrder,
    printResultOrder,
    exportResultOrder
}